import { DrowpDown } from "../../../assets/images/svg/icon";
import DetectedSensitiveWordType from "./enum/type";
import "../style.scss";
import CustomValuesHook from "../../../Hooks/customValuesHook";
import { useEffect } from "react";
import { getDetectedSensitiveWordLog } from "../../../api/requestAxios/getDetectedSensitiveWordLog";
import { ErrorToast } from "../../../shared";
import { IData } from "../../../api/modelAPI/detectedSensitiveWordLog";

type Props = {
  setSelect: Function;
  select: any;
};

const CustomerFilter = ({ setSelect, select }: Props) => {
  const [states, setStates] = CustomValuesHook({
    disablePaging: true,
    sortText: "",
    whereConditionText: "",
  });

  const [val, setVal] = CustomValuesHook({
    loading: false,
    customerList: [],
  });

  useEffect(() => {
    let whereConditionText = "";
    if (select?.statusCustomer && select?.typeActivity)
      whereConditionText = `Type=${select?.typeActivity} && State=${select?.statusCustomer}`;
    else if (select?.statusCustomer)
      whereConditionText = `State=${select?.statusCustomer}`;

    getLog(whereConditionText);
  }, [select]);

  const getLog = async (whereCondition: string) => {
    setVal({ loading: true });
    try {
      let tmpStates = { ...states };
      tmpStates.whereConditionText = whereCondition;
      const response = await getDetectedSensitiveWordLog(tmpStates);
      setVal({ loading: false });
      let tmp: IData[] = response?.data?.data;
      const distinctList = tmp.filter(
        (item, index, self) =>
          self.findIndex((t) => t.customerId === item.customerId) === index
      );
      setVal({ customerList: distinctList });
    } catch (error) {
      setVal({ loading: false });
      ErrorToast(error);
    }
  };

  const showValue = () => {
    const _idx = val?.customerList.indexOf(
      (val: any) => val?.customerId === select?.customerId
    );
    return val?.customerList[_idx];
  };

  return (
    <div className="d-flex justify-content-start align-items-center  ">
      <span>نام مشترک:</span>
      <div className="select-wrapper">
        <select
          className="form-control type-activity"
          onChange={(e) => setSelect({ customerId: e.target.value })}
          value={showValue()}
        >
          <option value="">همه</option>
          {val?.customerList?.map((_item: any) => {
            return (
              <option key={_item?.customerId} value={_item?.customerId}>
                {_item?.customerFullName}
              </option>
            );
          })}
        </select>
        <span className="icon-selector">
          <DrowpDown />
        </span>
      </div>
    </div>
  );
};

export default CustomerFilter;
